export default __webpack_public_path__ + "static/media/3.d10d29b6.png";